import { Component, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';

@Component({
  selector: 'app-select',
  template: `
    <ng-container
      *ngIf="
        field.name !== 'StateId' &&
        field.name !== 'LgaId' &&
        field.name !== 'DepartmentId'
      "
    >
      <div *ngIf="field.name !== 'CountryId' && field.name !== 'FacultyId'">
        <mat-form-field
          class="full-width-field"
          [formGroup]="group"
          id="id_number"
        >
          <mat-select
            [placeholder]="field.label"
            [formControlName]="field.name"
            (selectionChange)="onSelect($event.value)"
          >
            <mat-option *ngFor="let item of field.options" [value]="item.id">{{
              item.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="field.name === 'CountryId'">
        <mat-form-field
          class="full-width-field"
          [formGroup]="group"
          id="id_number"
        >
          <mat-select
            placeholder="Select LGA "
            formControlName="LgaId"
            (selectionChange)="onSelect($event)"
          >
            <div *ngFor="let level1 of field.options">
              <mat-optgroup
                *ngIf="level1.name; else leaf"
                [label]="level1.name"
              >
                <mat-select>
                  <div *ngFor="let level2 of level1.states">
                    <mat-optgroup
                      *ngIf="level2.name; else leaf"
                      [label]="level2.name"
                    >
                      <mat-select>
                        <mat-option
                          *ngFor="let level3 of level2.lgas"
                          [value]="level3.id"
                          >{{ level3.name }}</mat-option
                        >
                      </mat-select>
                    </mat-optgroup>
                    <ng-template #leaf>
                      <mat-option [value]="level2.id">{{
                        level1.name + ' ' + level2.name
                      }}</mat-option>
                    </ng-template>
                  </div>
                </mat-select>
              </mat-optgroup>
              <ng-template #leaf>
                <mat-option [value]="level1.id">{{ level1.name }}</mat-option>
              </ng-template>
            </div>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="field.name === 'FacultyId'">
        <mat-form-field
          class="full-width-field"
          [formGroup]="group"
          id="id_number"
        >
          <mat-select
            placeholder="Select Faculty "
            formControlName="DepartmentId"
            (selectionChange)="onSelect($event)"
          >
            <div *ngFor="let level1 of field.options">
              <mat-optgroup
                *ngIf="level1.name; else leaf"
                [label]="level1.name"
              >
                <mat-select>
                  <mat-option
                    *ngFor="let level3 of level1.departments"
                    [value]="level3.id"
                    >{{ level3.name }}</mat-option
                  >
                </mat-select>
              </mat-optgroup>
              <ng-template #leaf>
                <mat-option [value]="level1.id">{{ level1.name }}</mat-option>
              </ng-template>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>
  `,
  styles: [],
})
export class SelectComponent implements OnInit {
  field: any;
  group: FormGroup;
  newField;
  newArray;
  constructor() {}
  ngOnInit() {}

  onSelect(value) {
    // console.log('selected 1', this.field);
    // if (
    //   this.field.name.toLowerCase() === 'stateid' ||
    //   this.field.name.toLowerCase() === 'countryid'
    // ) {
    //   if (this.field.name.toLowerCase() === 'stateid') {
    //     this.field.options.forEach((item) => item['CountryId'] === value.id);
    //     console.log('selected ', this.field);
    //   }
    // }
    // switch (this.field.name.toLowerCase()) {
    //   case 'countryid':
    //     this.field.options = this.field.options.filter(
    //       (item) => item['CountryId'] === value.id
    //     );
    //     console.log('selected ', this.field.options);
    //     break;
    //   case 'stateid':
    //     this.field.options = this.field.options.filter(
    //       (item) => item.id === value.id
    //     );
    //     console.log('selected ', this.field.options);
    //     break;
    //   default:
    //     break;
    // }
  }
}
